












import {Vue, Prop, Component} from 'vue-property-decorator'
import { DependentLetter } from '../../../../store/models/Letter/DependentLetter'
@Component
export default class DependentItemMobile extends Vue{
    @Prop() letter?: DependentLetter;
    get dependencyType(){
        if(!this.letter)return '';
        switch(this.letter.dependencyType){
            case 'bending': return 'عطف';
            case 'following': return 'پیرو';
            case 'returning': return 'بازگشت';
            case 'attaching': return 'پیوست به';
            default: return '';
        }
    }

}
